import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-method-services',
  templateUrl: './delivery-method-services.component.html',
  styleUrls: ['./delivery-method-services.component.css'],
  standalone: false
})
export class DeliveryMethodServicesComponent implements OnInit {
    deliveryMethodNo;

    public menu?: Menu;

    public itemsListServices: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.deliveryMethodNo = this.stateService.getStateParams()['deliverymethod_no'];
    }

    private async loadMenu() {
        if (!!this.deliveryMethodNo) {
            this.menu = (await this.datatask.Post(2659, { deliverymethod_no: this.deliveryMethodNo }))[0];
        }
    }

    private async loadServices(): Promise<void> {
        if (!!this.menu) {
            this.itemsListServices = await this.datatask.Post(2656, this.menu);
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadServices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    deliverymethod_no: number;
    deliverymethod_name: string;
    transcarrier_keyno: number;
    transcarrier_name: string;
    transcarrier_product_keyno: number;
    transcarrier_product_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryMethodServices', {
//        templateUrl: 'views/components/views/deliveryMethodServices/deliveryMethodServices.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'deliveryMethodServicesService', function ($stateParams, deliveryMethodServicesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;

//            vm.model = {
//                menu: {},
//                itemsListServices: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await deliveryMethodServicesService.getMenu({ deliverymethod_no: deliveryMethodNo }))[0];

//                loadServices();
//            }

//            async function loadServices() {
//                vm.model.itemsListServices = (await deliveryMethodServicesService.listServices(vm.model.menu));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
